import React, { useState } from "react";
import PropTypes from "prop-types";
import TeaserBase from "../../../teaser-base/teaser-base";

// Overview related components
import OverviewProvider from "./store/overview-provider";
import useOverviewContext from "./store/use-overview-context";
import Filters from "./components/filters";

import NoResults from "./components/system/no-results";
import Loading from "./components/system/loading";
import Error from "./components/system/error";
import EndlessScroll from "./components/system/endless-scroll";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { rewriteProjektSchema } from "../../../teaser-base/project/rewrite-projekt-schema";
import classNames from "classnames";

/**
 * Renders the Overview module.
 * This component is wrapped by the overview context provider at the end of
 * this file. The whole state of this module is handled by the overview context
 * located in ./store.
 */
const OverviewDefault = ({ content }) => {
  // Get relevant values from the OverviewContext.
  const { items, error } = useOverviewContext();
  const [filterOpen, setFilterOpen] = useState(false);

  return (
    <section
      className={`paragraph paragraph-overview type-${content.fieldContentType} paragraph-extended-teaser-view`}
    >
      <Filters
        filterOpen={filterOpen}
        closeFilters={() => setFilterOpen(false)}
      />
      <div className="container nodes">
        {!!items?.length && !error && (
          <ResponsiveMasonry
            columnsCountBreakPoints={{ 575: 1, 767: 2, 1023: 3 }}
          >
            <Masonry gutter="20px">
              {items.map((item, i) => (
                <div key={i}>
                  <TeaserBase item={rewriteProjektSchema(item)} />
                </div>
              ))}
            </Masonry>
          </ResponsiveMasonry>
        )}

        <NoResults />
        <Loading />
        <Error />

        {/* Pagination */}
        {/* <Pagination /> */}

        {/* Endless scroll (uncomment and import to use it) */}
        <EndlessScroll rootMargin={3000} />
      </div>

      <div
        className={classNames({
          "d-block d-xl-none open-filter-button": true,
          //"d-none": background,
        })}
        onClick={() => setFilterOpen((prev) => !prev)}
      >
        Filter
      </div>
    </section>
  );
};

// Wrap the Overview component with the OverviewProvider.
const ParagraphOverview = ({ content }) => {
  return (
    <OverviewProvider bundle={"projects"}>
      {(() => {
        switch (content.fieldContentType) {
          default:
            return <OverviewDefault content={content} />;
        }
      })()}
    </OverviewProvider>
  );
};

ParagraphOverview.propTypes = {
  content: PropTypes.shape({
    fieldContentType: PropTypes.oneOf(["news", "event", "projekt", "person"]),
  }),
};

export default ParagraphOverview;
